import api from "./api";
import Menu from "@/model/menu";
import MenuSet from "@/model/menuSet";
import SetMenuItem from "@/model/setMenuItem";
import Option from "@/model/option";

class ItemApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async index() {
    const identifierCategories = []
    const result = []

    const response = await this.getHttp().get<any>('items');
    const items = response.data.data.items
    const categories = response.data.data.categories

    categories.map(category => {
      identifierCategories.push(category.identifier.toString())
    })

    const uniqueItems = [
      ...new Map(items.map(item => [item['identifier'], item])).values(),
    ]
    const dataList = JSON.parse(JSON.stringify(uniqueItems))

    dataList.map(value => {
      if (identifierCategories.includes(value.itemCategory.toString())) {
        result.push(value)
      }
    })

    result.sort((a,b) => (a.itemCategory > b.itemCategory ? 1 : -1))

    return result.map(item => {
      return new Menu({
        ...item, ...{
          quantity: 0,
          isSpicy: false
        }
      })
    })
  }

  async getList() {
    const response = await this.getHttp().get<any>('items');
    const items = response.data.data.items

    return items.map(item => {
      return new Menu({
        ...item, ...{
          quantity: 0,
          isSpicy: false
        }
      })
    })
  }

  async getSetMenu() {
    const response = await this.getHttp().get<any>('items');
    const setMenus = response.data.data.set_menus
    const setMenuItems = Object.values(response.data.data.set_menu_items)
    const setMenuItemKeys = Object.keys(response.data.data.set_menu_items)

    return {
      'setMenus': setMenus ?? [],
      'setMenuItems': setMenuItems ?? [],
      'setMenuItemKeys': setMenuItemKeys ?? []
    }
  }

  async getOptions() {
    const responses = await this.getHttp().get<any>('items');
    const items = responses.data.data.items
    const options = []

    items.map(item => {
      if (item.subIdentifier !== "") {
        options.push(new Option({
          identifier: item.identifier.toString(),
          subIdentifier: item.subIdentifier.toString(),
          subName: item.subName.toString(),
          subNameEn: (item.subNameEn) ? item.subNameEn.toString() : '',
          subNameCn: (item.subNameCn) ? item.subNameCn.toString() : '',
          subNameKr: (item.subNameKr) ? item.subNameKr.toString() : '',
          quantity: 0,
        }))
      }
    })

    return options
  }

  async getMenuSetListByIdentifier(identifier, setMenus, setMenuItemKeys, setMenuItems) {
    const setMenuList = await this.prepareSetMenuItems(setMenuItems, setMenuItemKeys)
    if (typeof setMenus[identifier.toString()] !== "undefined") {
      return setMenus[identifier.toString()].map(item => {
        if (item.item_keys.length > 0) {
          item.options = item.item_keys.map(value => {
            return new SetMenuItem(this.getSetMenuItemByIdentifier(setMenuList, value))
          })
        }
        return new MenuSet({
          identifier: identifier,
          ...item
        })
      })
    }
    return [];
  }

  async prepareSetMenuItems(setMenuItems, setMenuItemKeys) {
    const result = []
    setMenuItems.map(item => {
      result.push(item)
    })
    result.map((item, key) => item.identifier = setMenuItemKeys[key]);

    return result
  }

  async getRecommendedList() {
    const items = await this.index();
    const menuRecommended = []
    items.map(value => {
      if (value.ranking !== "" && Number.parseInt(value.ranking) > 0) {
        menuRecommended.push(value)
      }
    })

    return menuRecommended.sort((a,b) => (a.ranking > b.ranking ? 1 : -1))
  }

  async getMenuByIdentifier(identifier) {
    const items = await this.index();
    const menu = []
    items.map(item => {
      if (item.identifier === identifier) {
        menu.push(item)
      }
    });

    if (menu) {
      return menu[0]
    }

    return menu
  }

  private getSetMenuItemByIdentifier(items, value) {
    let setMenuItem = new SetMenuItem();
    items.map(item => {
      if (item.identifier === value) {
        setMenuItem = new SetMenuItem({
          ...item, ...{
            quantity: 0
          }
        })
      }
    });

    return setMenuItem;
  }
}

export default new ItemApi();
